import { Grid, Typography } from "@mui/material";
import styles from "../contactus.module.scss";
import { useEffect } from "react";
import {
  CustomLeftIcon,
  CommonButton,
} from "../../common/StyledComponents/StyledFields";

interface PublicTransportationProps {
  setShowAddressComponent: React.Dispatch<React.SetStateAction<boolean>>;
}
const PublicTransportation: React.FC<PublicTransportationProps> = ({
  setShowAddressComponent,
}) => {
  const navigateBack = () => {
    setShowAddressComponent(true);
  };
  const handlePrint = () => {
    window.print();
  };
  return (
    <>
      <div className={styles.PublicTransportationLayout}>
        <Grid>
          <Typography className={styles.typoGraphyHeading}>
            <span onClick={navigateBack}>
              <CustomLeftIcon />
            </span>{" "}
            Public Transportation
          </Typography>
        </Grid>
        <div style={{ padding: "24px" }}>
          <Typography className={styles.contnet}>
            <p>
              You can plan and get the estimate of time and the actual route to the 
              temple by using the transit authorities web site{" "}
              <a
                href="https://wheelsbus.com/trip-planner"
                target="_blank"
                style={{ color: "#000099" }}
              >
                https://wheelsbus.com/trip-planner.
              </a>
            </p>

            <p>
              We do have public Transportation connection to the Temple, 
              and we encourage you to use them as much as possible when you come to the Temple,
               especially on crowded days like Jan 1st, Sri Rama Navami celebrations, etc.,
                Also, if you cannot drive, then the safest and independent way to visit the Temple is by using the
                 Public Transportation.
            </p>

            <p>
              The Tri-City - Livermore, Pleasanton, Dublin area is served by the 
              Livermore Amador Valley Transit Authority (LAVTA){" "}
              <a
                href="http://www.lavta.org"
                target="_blank"
                style={{ color: "#000099" }}
              >
                http://www.lavta.org.{" "}
              </a>
              Their buses have "Wheels" written on them. They connect our Temple from other
               public Transportation providers such as BART, ACE, AC Transit and Greyhound. 
               "Wheels" buses don't stop exactly at the Temple door. 
               You have to get down at the Bluebell drive bus stop and walk a couple of minutes. 
               Route #15 and route #11 are only two routes of LAVTA that come close to our Temple. 
               For more info about "Wheels" buses call (925) 455-7500.
            </p>

            <p>
              If you stay close to BART lines, you can take BART trains to Pleasanton and then 
              ride route #10R bus to Livermore Transit center and change to another bus such as 
              route #11 or route #15 to come to Temple. If you plan to come that way, 
              note that you have to pay only $2.00 per trip or $ 3.75 per day{" "}
              <a
                href="https://countyconnection.com/fares/transfers"
                target="_blank"
                style={{ color: "#000099" }}
              >
                https://countyconnection.com/fares/transfers.{" "}
              </a>
              for the bus ride if you transfer from BART{" "}
              <a
                href="https://www.actransit.org/website/uploads/HSP_WDUB-sched.pdf"
                target="_blank"
                style={{ color: "#000099" }}
              >
                https://www.actransit.org/website/uploads/HSP_WDUB-sched.pdf.{" "}
              </a>
              and transferring from one "Wheels" bus to the other is FREE. 
              Ask the bus driver if you have any questions. Note that route #10R operates at 
              a different schedule on Weekdays, Saturdays, and Sundays.
            </p>

            <p>
              From Livermore Transit Center, you can take either route #15 or route #11 to 
              reach Bluebell drive bus stop. These buses leave the Transit center every hour 
              and they operate with different schedules on Weekdays and Saturdays, 
              while they don't operate on Holidays and Sundays. From the Transit center, 
              Route #15 directly goes to Bluebell drive bus stop and then goes around 
              Springtown golf course to arrive back at the intersection of Bluebell Drive-Springtown 
              Blvd intersection about twenty minutes later. But route #11 goes around Springtown golf 
              course first and arrives at the Bluebell drive bus stop about twenty minutes after it passes 
              the intersection of Bluebell drive and Springtown Blvd. So, if you don't mind walking a 
              couple more minutes while riding route #11, just get down at the intersection.
            </p>

            <p>
              {" "}
              If you would like to come from the San Jose area, you can come by ACE Train, their schedule is located at{" "}
              <a
                href="https://acerail.com/schedules/"
                target="_blank"
                style={{ color: "#000099" }}
              >
                https://acerail.com/schedules/{" "}
              </a>
              Or you can take Route #180 up to Fremont BART station. See{" "}
              <a
                href="https://www.vta.org/trip-planner"
                target="_blank"
                style={{ color: "#000099" }}
              >
                https://www.vta.org/trip-planner{" "}
              </a>
              From there take BART and change at Bay Fair station to reach Pleasanton BART station. 
              From there you can take Route #10R to come to Livermore Transit Center and then 
              take a Wheels on route #11 or route #15.
            </p>

            <p>
              Uber and Lyft vehicles come from anywhere in the Bay area right up to the temple and vice versa.{" "}
            </p>
          </Typography>
        </div>
        <div className={styles.printbutton}>
          <CommonButton onClick={handlePrint}>Print</CommonButton>
        </div>
      </div>
    </>
  );
};
export default PublicTransportation;
